import { createListLoadingReducer } from './utils';

export default createListLoadingReducer('CUSTOMER_COMMENTS');
